import { AppShell, ScrollArea } from "@mantine/core";
import { AdminSidebar } from "./components/admin/admin-sidebar.component";
import { Navbar } from "./components/navbar/navbar.component";

export function AdminLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppShell
      style={{ overflow: "hidden" }}
      header={{ height: 70 }}
      navbar={{ width: 50, breakpoint: "sm" }}
    >
      <ScrollArea h={"100vh"} scrollbarSize={7}>
        <AppShell.Header>
          <Navbar />
        </AppShell.Header>

        <AppShell.Navbar px={12}>
          <AdminSidebar />
        </AppShell.Navbar>
        <AppShell.Main h={"calc(100vh - 55px)"}>{children}</AppShell.Main>
      </ScrollArea>
    </AppShell>
  );
}
